module.exports = __webpack_public_path__ + "static/img/play.9c6765ef.svg";